export const COUNTRIES_FULL_LIST = [
  {
    id: '1',
    country: 'Aruba',
    code: 'ABW',
    status: 'ok'
  },
  {
    id: '2',
    country: 'Afghanistan',
    code: 'AFG',
    status: 'ok'
  },
  {
    id: '3',
    country: 'Angola',
    code: 'AGO',
    status: 'ok'
  },
  {
    id: '4',
    country: 'Anguilla',
    code: 'AIA',
    status: 'ok'
  },
  {
    id: '5',
    country: 'Åland Islands',
    code: 'ALA',
    status: 'ok'
  },
  {
    id: '6',
    country: 'Albania',
    code: 'ALB',
    status: 'ok'
  },
  {
    id: '7',
    country: 'Andorra',
    code: 'AND',
    status: 'ok'
  },
  {
    id: '8',
    country: 'United Arab Emirates',
    code: 'ARE',
    status: 'ok'
  },
  {
    id: '9',
    country: 'Argentina',
    code: 'ARG',
    status: 'ok'
  },
  {
    id: '10',
    country: 'Armenia',
    code: 'ARM',
    status: 'ok'
  },
  {
    id: '11',
    country: 'American Samoa',
    code: 'ASM',
    status: 'ok'
  },
  {
    id: '12',
    country: 'Antarctica',
    code: 'ATA',
    status: 'ok'
  },
  {
    id: '13',
    country: 'French Southern Territories',
    code: 'ATF',
    status: 'ok'
  },
  {
    id: '14',
    country: 'Antigua and Barbuda',
    code: 'ATG',
    status: 'ok'
  },
  {
    id: '15',
    country: 'Australia',
    code: 'AUS',
    status: 'ok'
  },
  {
    id: '16',
    country: 'Austria',
    code: 'AUT',
    status: 'ok'
  },
  {
    id: '17',
    country: 'Azerbaijan',
    code: 'AZE',
    status: 'ok'
  },
  {
    id: '18',
    country: 'Burundi',
    code: 'BDI',
    status: 'ok'
  },
  {
    id: '19',
    country: 'Belgium',
    code: 'BEL',
    status: 'ok'
  },
  {
    id: '20',
    country: 'Benin',
    code: 'BEN',
    status: 'ok'
  },
  {
    id: '21',
    country: 'Bonaire, Sint Eustatius and Saba',
    code: 'BES',
    status: 'ok'
  },
  {
    id: '22',
    country: 'Burkina Faso',
    code: 'BFA',
    status: 'ok'
  },
  {
    id: '23',
    country: 'Bangladesh',
    code: 'BGD',
    status: 'ok'
  },
  {
    id: '24',
    country: 'Bulgaria',
    code: 'BGR',
    status: 'ok'
  },
  {
    id: '25',
    country: 'Bahrain',
    code: 'BHR',
    status: 'ok'
  },
  {
    id: '26',
    country: 'Bahamas',
    code: 'BHS',
    status: 'ok'
  },
  {
    id: '27',
    country: 'Bosnia and Herzegovina',
    code: 'BIH',
    status: 'ok'
  },
  {
    id: '28',
    country: 'Saint Barthélemy',
    code: 'BLM',
    status: 'ok'
  },
  {
    id: '29',
    country: 'Belarus',
    code: 'BLR',
    status: 'ok'
  },
  {
    id: '30',
    country: 'Belize',
    code: 'BLZ',
    status: 'ok'
  },
  {
    id: '31',
    country: 'Bermuda',
    code: 'BMU',
    status: 'ok'
  },
  {
    id: '32',
    country: 'Bolivia (Plurinational State of)',
    code: 'BOL',
    status: 'ok'
  },
  {
    id: '33',
    country: 'Brazil',
    code: 'BRA',
    status: 'ok'
  },
  {
    id: '34',
    country: 'Barbados',
    code: 'BRB',
    status: 'ok'
  },
  {
    id: '35',
    country: 'Brunei Darussalam',
    code: 'BRN',
    status: 'ok'
  },
  {
    id: '36',
    country: 'Bhutan',
    code: 'BTN',
    status: 'ok'
  },
  {
    id: '37',
    country: 'Bouvet Island',
    code: 'BVT',
    status: 'ok'
  },
  {
    id: '38',
    country: 'Botswana',
    code: 'BWA',
    status: 'ok'
  },
  {
    id: '39',
    country: 'Central African Republic',
    code: 'CAF',
    status: 'ok'
  },
  {
    id: '40',
    country: 'Canada',
    code: 'CAN',
    status: 'ok'
  },
  {
    id: '41',
    country: 'Cocos (Keeling) Islands',
    code: 'CCK',
    status: 'ok'
  },
  {
    id: '42',
    country: 'Switzerland',
    code: 'CHE',
    status: 'ok'
  },
  {
    id: '43',
    country: 'Chile',
    code: 'CHL',
    status: 'ok'
  },
  {
    id: '44',
    country: 'China',
    code: 'CHN',
    status: 'ok'
  },
  {
    id: '45',
    country: "Côte d'Ivoire",
    code: 'CIV',
    status: 'ok'
  },
  {
    id: '46',
    country: 'Cameroon',
    code: 'CMR',
    status: 'ok'
  },
  {
    id: '47',
    country: 'Congo, Democratic Republic of the',
    code: 'COD',
    status: 'ok'
  },
  {
    id: '48',
    country: 'Congo',
    code: 'COG',
    status: 'ok'
  },
  {
    id: '49',
    country: 'Cook Islands',
    code: 'COK',
    status: 'ok'
  },
  {
    id: '50',
    country: 'Colombia',
    code: 'COL',
    status: 'ok'
  },
  {
    id: '51',
    country: 'Comoros',
    code: 'COM',
    status: 'ok'
  },
  {
    id: '52',
    country: 'Cabo Verde',
    code: 'CPV',
    status: 'ok'
  },
  {
    id: '53',
    country: 'Costa Rica',
    code: 'CRI',
    status: 'ok'
  },
  {
    id: '54',
    country: 'Cuba',
    code: 'CUB',
    status: 'ok'
  },
  {
    id: '55',
    country: 'Curaçao',
    code: 'CUW',
    status: 'ok'
  },
  {
    id: '56',
    country: 'Christmas Island',
    code: 'CXR',
    status: 'ok'
  },
  {
    id: '57',
    country: 'Cayman Islands',
    code: 'CYM',
    status: 'ok'
  },
  {
    id: '58',
    country: 'Cyprus',
    code: 'CYP',
    status: 'ok'
  },
  {
    id: '59',
    country: 'Czechia',
    code: 'CZE',
    status: 'ok'
  },
  {
    id: '60',
    country: 'Germany',
    code: 'DEU',
    status: 'ok'
  },
  {
    id: '61',
    country: 'Djibouti',
    code: 'DJI',
    status: 'ok'
  },
  {
    id: '62',
    country: 'Dominica',
    code: 'DMA',
    status: 'ok'
  },
  {
    id: '63',
    country: 'Denmark',
    code: 'DNK',
    status: 'ok'
  },
  {
    id: '64',
    country: 'Dominican Republic',
    code: 'DOM',
    status: 'ok'
  },
  {
    id: '65',
    country: 'Algeria',
    code: 'DZA',
    status: 'ok'
  },
  {
    id: '66',
    country: 'Ecuador',
    code: 'ECU',
    status: 'ok'
  },
  {
    id: '67',
    country: 'Egypt',
    code: 'EGY',
    status: 'ok'
  },
  {
    id: '68',
    country: 'Eritrea',
    code: 'ERI',
    status: 'ok'
  },
  {
    id: '69',
    country: 'Western Sahara',
    code: 'ESH',
    status: 'ok'
  },
  {
    id: '70',
    country: 'Spain',
    code: 'ESP',
    status: 'ok'
  },
  {
    id: '71',
    country: 'Estonia',
    code: 'EST',
    status: 'ok'
  },
  {
    id: '72',
    country: 'Ethiopia',
    code: 'ETH',
    status: 'ok'
  },
  {
    id: '73',
    country: 'Finland',
    code: 'FIN',
    status: 'ok'
  },
  {
    id: '74',
    country: 'Fiji',
    code: 'FJI',
    status: 'ok'
  },
  {
    id: '75',
    country: 'Falkland Islands (Malvinas)',
    code: 'FLK',
    status: 'ok'
  },
  {
    id: '76',
    country: 'France',
    code: 'FRA',
    status: 'ok'
  },
  {
    id: '77',
    country: 'Faroe Islands',
    code: 'FRO',
    status: 'ok'
  },
  {
    id: '78',
    country: 'Micronesia (Federated States of)',
    code: 'FSM',
    status: 'ok'
  },
  {
    id: '79',
    country: 'Gabon',
    code: 'GAB',
    status: 'ok'
  },
  {
    id: '80',
    country: 'United Kingdom of Great Britain and Northern Ireland',
    code: 'GBR',
    status: 'ok'
  },
  {
    id: '81',
    country: 'Georgia',
    code: 'GEO',
    status: 'ok'
  },
  {
    id: '82',
    country: 'Guernsey',
    code: 'GGY',
    status: 'ok'
  },
  {
    id: '83',
    country: 'Ghana',
    code: 'GHA',
    status: 'ok'
  },
  {
    id: '84',
    country: 'Gibraltar',
    code: 'GIB',
    status: 'ok'
  },
  {
    id: '85',
    country: 'Guinea',
    code: 'GIN',
    status: 'ok'
  },
  {
    id: '86',
    country: 'Guadeloupe',
    code: 'GLP',
    status: 'ok'
  },
  {
    id: '87',
    country: 'Gambia',
    code: 'GMB',
    status: 'ok'
  },
  {
    id: '88',
    country: 'Guinea-Bissau',
    code: 'GNB',
    status: 'ok'
  },
  {
    id: '89',
    country: 'Equatorial Guinea',
    code: 'GNQ',
    status: 'ok'
  },
  {
    id: '90',
    country: 'Greece',
    code: 'GRC',
    status: 'ok'
  },
  {
    id: '91',
    country: 'Grenada',
    code: 'GRD',
    status: 'ok'
  },
  {
    id: '92',
    country: 'Greenland',
    code: 'GRL',
    status: 'ok'
  },
  {
    id: '93',
    country: 'Guatemala',
    code: 'GTM',
    status: 'ok'
  },
  {
    id: '94',
    country: 'French Guiana',
    code: 'GUF',
    status: 'ok'
  },
  {
    id: '95',
    country: 'Guam',
    code: 'GUM',
    status: 'ok'
  },
  {
    id: '96',
    country: 'Guyana',
    code: 'GUY',
    status: 'ok'
  },
  {
    id: '97',
    country: 'Hong Kong',
    code: 'HKG',
    status: 'ok'
  },
  {
    id: '98',
    country: 'Heard Island and McDonald Islands',
    code: 'HMD',
    status: 'ok'
  },
  {
    id: '99',
    country: 'Honduras',
    code: 'HND',
    status: 'ok'
  },
  {
    id: '100',
    country: 'Croatia',
    code: 'HRV',
    status: 'ok'
  },
  {
    id: '101',
    country: 'Haiti',
    code: 'HTI',
    status: 'ok'
  },
  {
    id: '102',
    country: 'Hungary',
    code: 'HUN',
    status: 'ok'
  },
  {
    id: '103',
    country: 'Indonesia',
    code: 'IDN',
    status: 'ok'
  },
  {
    id: '104',
    country: 'Isle of Man',
    code: 'IMN',
    status: 'ok'
  },
  {
    id: '105',
    country: 'India',
    code: 'IND',
    status: 'ok'
  },
  {
    id: '106',
    country: 'British Indian Ocean Territory',
    code: 'IOT',
    status: 'ok'
  },
  {
    id: '107',
    country: 'Ireland',
    code: 'IRL',
    status: 'ok'
  },
  {
    id: '108',
    country: 'Iran (Islamic Republic of)',
    code: 'IRN',
    status: 'ok'
  },
  {
    id: '109',
    country: 'Iraq',
    code: 'IRQ',
    status: 'ok'
  },
  {
    id: '110',
    country: 'Iceland',
    code: 'ISL',
    status: 'ok'
  },
  {
    id: '111',
    country: 'Israel',
    code: 'ISR',
    status: 'ok'
  },
  {
    id: '112',
    country: 'Italy',
    code: 'ITA',
    status: 'ok'
  },
  {
    id: '113',
    country: 'Jamaica',
    code: 'JAM',
    status: 'ok'
  },
  {
    id: '114',
    country: 'Jersey',
    code: 'JEY',
    status: 'ok'
  },
  {
    id: '115',
    country: 'Jordan',
    code: 'JOR',
    status: 'ok'
  },
  {
    id: '116',
    country: 'Japan',
    code: 'JPN',
    status: 'ok'
  },
  {
    id: '117',
    country: 'Kazakhstan',
    code: 'KAZ',
    status: 'ok'
  },
  {
    id: '118',
    country: 'Kenya',
    code: 'KEN',
    status: 'ok'
  },
  {
    id: '119',
    country: 'Kyrgyzstan',
    code: 'KGZ',
    status: 'ok'
  },
  {
    id: '120',
    country: 'Cambodia',
    code: 'KHM',
    status: 'ok'
  },
  {
    id: '121',
    country: 'Kiribati',
    code: 'KIR',
    status: 'ok'
  },
  {
    id: '122',
    country: 'Saint Kitts and Nevis',
    code: 'KNA',
    status: 'ok'
  },
  {
    id: '123',
    country: 'Korea, Republic of',
    code: 'KOR',
    status: 'ok'
  },
  {
    id: '124',
    country: 'Kuwait',
    code: 'KWT',
    status: 'ok'
  },
  {
    id: '125',
    country: "Lao People's Democratic Republic",
    code: 'LAO',
    status: 'ok'
  },
  {
    id: '126',
    country: 'Lebanon',
    code: 'LBN',
    status: 'ok'
  },
  {
    id: '127',
    country: 'Liberia',
    code: 'LBR',
    status: 'ok'
  },
  {
    id: '128',
    country: 'Libya',
    code: 'LBY',
    status: 'ok'
  },
  {
    id: '129',
    country: 'Saint Lucia',
    code: 'LCA',
    status: 'ok'
  },
  {
    id: '130',
    country: 'Liechtenstein',
    code: 'LIE',
    status: 'ok'
  },
  {
    id: '131',
    country: 'Sri Lanka',
    code: 'LKA',
    status: 'ok'
  },
  {
    id: '132',
    country: 'Lesotho',
    code: 'LSO',
    status: 'ok'
  },
  {
    id: '133',
    country: 'Lithuania',
    code: 'LTU',
    status: 'ok'
  },
  {
    id: '134',
    country: 'Luxembourg',
    code: 'LUX',
    status: 'ok'
  },
  {
    id: '135',
    country: 'Latvia',
    code: 'LVA',
    status: 'ok'
  },
  {
    id: '136',
    country: 'Macao',
    code: 'MAC',
    status: 'ok'
  },
  {
    id: '137',
    country: 'Saint Martin (French part)',
    code: 'MAF',
    status: 'ok'
  },
  {
    id: '138',
    country: 'Morocco',
    code: 'MAR',
    status: 'ok'
  },
  {
    id: '139',
    country: 'Monaco',
    code: 'MCO',
    status: 'ok'
  },
  {
    id: '140',
    country: 'Republic of Moldova',
    code: 'MDA',
    status: 'ok'
  },
  {
    id: '141',
    country: 'Madagascar',
    code: 'MDG',
    status: 'ok'
  },
  {
    id: '142',
    country: 'Maldives',
    code: 'MDV',
    status: 'ok'
  },
  {
    id: '143',
    country: 'Mexico',
    code: 'MEX',
    status: 'ok'
  },
  {
    id: '144',
    country: 'Marshall Islands',
    code: 'MHL',
    status: 'ok'
  },
  {
    id: '145',
    country: 'North Macedonia',
    code: 'MKD',
    status: 'ok'
  },
  {
    id: '146',
    country: 'Mali',
    code: 'MLI',
    status: 'ok'
  },
  {
    id: '147',
    country: 'Malta',
    code: 'MLT',
    status: 'ok'
  },
  {
    id: '148',
    country: 'Myanmar',
    code: 'MMR',
    status: 'ok'
  },
  {
    id: '149',
    country: 'Montenegro',
    code: 'MNE',
    status: 'ok'
  },
  {
    id: '150',
    country: 'Mongolia',
    code: 'MNG',
    status: 'ok'
  },
  {
    id: '151',
    country: 'Northern Mariana Islands',
    code: 'MNP',
    status: 'ok'
  },
  {
    id: '152',
    country: 'Mozambique',
    code: 'MOZ',
    status: 'ok'
  },
  {
    id: '153',
    country: 'Mauritania',
    code: 'MRT',
    status: 'ok'
  },
  {
    id: '154',
    country: 'Montserrat',
    code: 'MSR',
    status: 'ok'
  },
  {
    id: '155',
    country: 'Martinique',
    code: 'MTQ',
    status: 'ok'
  },
  {
    id: '156',
    country: 'Mauritius',
    code: 'MUS',
    status: 'ok'
  },
  {
    id: '157',
    country: 'Malawi',
    code: 'MWI',
    status: 'ok'
  },
  {
    id: '158',
    country: 'Malaysia',
    code: 'MYS',
    status: 'ok'
  },
  {
    id: '159',
    country: 'Mayotte',
    code: 'MYT',
    status: 'ok'
  },
  {
    id: '160',
    country: 'Namibia',
    code: 'NAM',
    status: 'ok'
  },
  {
    id: '161',
    country: 'New Caledonia',
    code: 'NCL',
    status: 'ok'
  },
  {
    id: '162',
    country: 'Niger',
    code: 'NER',
    status: 'ok'
  },
  {
    id: '163',
    country: 'Norfolk Island',
    code: 'NFK',
    status: 'ok'
  },
  {
    id: '164',
    country: 'Nigeria',
    code: 'NGA',
    status: 'ok'
  },
  {
    id: '165',
    country: 'Niue',
    code: 'NIU',
    status: 'ok'
  },
  {
    id: '166',
    country: 'Netherlands',
    code: 'NLD',
    status: 'ok'
  },
  {
    id: '167',
    country: 'Norway',
    code: 'NOR',
    status: 'ok'
  },
  {
    id: '168',
    country: 'Nepal',
    code: 'NPL',
    status: 'ok'
  },
  {
    id: '169',
    country: 'Nauru',
    code: 'NRU',
    status: 'ok'
  },
  {
    id: '170',
    country: 'New Zealand',
    code: 'NZL',
    status: 'ok'
  },
  {
    id: '171',
    country: 'Oman',
    code: 'OMN',
    status: 'ok'
  },
  {
    id: '172',
    country: 'Pakistan',
    code: 'PAK',
    status: 'ok'
  },
  {
    id: '173',
    country: 'Panama',
    code: 'PAN',
    status: 'ok'
  },
  {
    id: '174',
    country: 'Pitcairn',
    code: 'PCN',
    status: 'ok'
  },
  {
    id: '175',
    country: 'Peru',
    code: 'PER',
    status: 'ok'
  },
  {
    id: '176',
    country: 'Philippines',
    code: 'PHL',
    status: 'ok'
  },
  {
    id: '177',
    country: 'Palau',
    code: 'PLW',
    status: 'ok'
  },
  {
    id: '178',
    country: 'Papua New Guinea',
    code: 'PNG',
    status: 'ok'
  },
  {
    id: '179',
    country: 'Poland',
    code: 'POL',
    status: 'ok'
  },
  {
    id: '180',
    country: 'Puerto Rico',
    code: 'PRI',
    status: 'ok'
  },
  {
    id: '181',
    country: "Korea (Democratic People's Republic of)",
    code: 'PRK',
    status: 'banned'
  },
  {
    id: '182',
    country: 'Portugal',
    code: 'PRT',
    status: 'ok'
  },
  {
    id: '183',
    country: 'Paraguay',
    code: 'PRY',
    status: 'ok'
  },
  {
    id: '184',
    country: 'Palestine, State of',
    code: 'PSE',
    status: 'ok'
  },
  {
    id: '185',
    country: 'French Polynesia',
    code: 'PYF',
    status: 'ok'
  },
  {
    id: '186',
    country: 'Qatar',
    code: 'QAT',
    status: 'ok'
  },
  {
    id: '187',
    country: 'Réunion',
    code: 'REU',
    status: 'ok'
  },
  {
    id: '188',
    country: 'Romania',
    code: 'ROU',
    status: 'ok'
  },
  {
    id: '189',
    country: 'Russian Federation',
    code: 'RUS',
    status: 'ok'
  },
  {
    id: '190',
    country: 'Rwanda',
    code: 'RWA',
    status: 'ok'
  },
  {
    id: '191',
    country: 'Saudi Arabia',
    code: 'SAU',
    status: 'ok'
  },
  {
    id: '192',
    country: 'Sudan',
    code: 'SDN',
    status: 'ok'
  },
  {
    id: '193',
    country: 'Senegal',
    code: 'SEN',
    status: 'ok'
  },
  {
    id: '194',
    country: 'Singapore',
    code: 'SGP',
    status: 'ok'
  },
  {
    id: '195',
    country: 'South Georgia and the South Sandwich Islands',
    code: 'SHN',
    status: 'ok'
  },
  {
    id: '196',
    country: 'Svalbard and Jan Mayen',
    code: 'SJM',
    status: 'ok'
  },
  {
    id: '197',
    country: 'Solomon Islands',
    code: 'SLB',
    status: 'ok'
  },
  {
    id: '198',
    country: 'Sierra Leone',
    code: 'SLE',
    status: 'ok'
  },
  {
    id: '199',
    country: 'El Salvador',
    code: 'SLV',
    status: 'ok'
  },
  {
    id: '200',
    country: 'San Marino',
    code: 'SMR',
    status: 'ok'
  },
  {
    id: '201',
    country: 'Somalia',
    code: 'SOM',
    status: 'ok'
  },
  {
    id: '202',
    country: 'Saint Pierre and Miquelon',
    code: 'SPM',
    status: 'ok'
  },
  {
    id: '203',
    country: 'Serbia',
    code: 'SRB',
    status: 'ok'
  },
  {
    id: '204',
    country: 'South Sudan',
    code: 'SSD',
    status: 'ok'
  },
  {
    id: '205',
    country: 'Sao Tome and Principe',
    code: 'STP',
    status: 'ok'
  },
  {
    id: '206',
    country: 'Suriname',
    code: 'SUR',
    status: 'ok'
  },
  {
    id: '207',
    country: 'Slovakia',
    code: 'SVK',
    status: 'ok'
  },
  {
    id: '208',
    country: 'Slovenia',
    code: 'SVN',
    status: 'ok'
  },
  {
    id: '209',
    country: 'Sweden',
    code: 'SWE',
    status: 'ok'
  },
  {
    id: '210',
    country: 'Eswatini',
    code: 'SWZ',
    status: 'ok'
  },
  {
    id: '211',
    country: 'Sint Maarten (Dutch part)',
    code: 'SXM',
    status: 'ok'
  },
  {
    id: '212',
    country: 'Seychelles',
    code: 'SYC',
    status: 'ok'
  },
  {
    id: '213',
    country: 'Syrian Arab Republic',
    code: 'SYR',
    status: 'ok'
  },
  {
    id: '214',
    country: 'Turks and Caicos Islands',
    code: 'TCA',
    status: 'ok'
  },
  {
    id: '215',
    country: 'Chad',
    code: 'TCD',
    status: 'ok'
  },
  {
    id: '216',
    country: 'Togo',
    code: 'TGO',
    status: 'ok'
  },
  {
    id: '217',
    country: 'Thailand',
    code: 'THA',
    status: 'ok'
  },
  {
    id: '218',
    country: 'Tajikistan',
    code: 'TJK',
    status: 'ok'
  },
  {
    id: '219',
    country: 'Tokelau',
    code: 'TKL',
    status: 'ok'
  },
  {
    id: '220',
    country: 'Turkmenistan',
    code: 'TKM',
    status: 'ok'
  },
  {
    id: '221',
    country: 'Timor-Leste',
    code: 'TLS',
    status: 'ok'
  },
  {
    id: '222',
    country: 'Tonga',
    code: 'TON',
    status: 'ok'
  },
  {
    id: '223',
    country: 'Trinidad and Tobago',
    code: 'TTO',
    status: 'ok'
  },
  {
    id: '224',
    country: 'Tunisia',
    code: 'TUN',
    status: 'ok'
  },
  {
    id: '225',
    country: 'Turkey',
    code: 'TUR',
    status: 'ok'
  },
  {
    id: '226',
    country: 'Tuvalu',
    code: 'TUV',
    status: 'ok'
  },
  {
    id: '227',
    country: 'Taiwan, Province of China',
    code: 'TWN',
    status: 'ok'
  },
  {
    id: '228',
    country: 'Tanzania, United Republic of',
    code: 'TZA',
    status: 'ok'
  },
  {
    id: '229',
    country: 'Uganda',
    code: 'UGA',
    status: 'ok'
  },
  {
    id: '230',
    country: 'Ukraine',
    code: 'UKR',
    status: 'ok'
  },
  {
    id: '231',
    country: 'United States Minor Outlying Islands',
    code: 'UMI',
    status: 'ok'
  },
  {
    id: '232',
    country: 'Uruguay',
    code: 'URY',
    status: 'ok'
  },
  {
    id: '233',
    country: 'United States of America',
    code: 'USA',
    status: 'banned'
  },
  {
    id: '234',
    country: 'Holy See',
    code: 'VAT',
    status: 'ok'
  },
  {
    id: '235',
    country: 'Saint Vincent and the Grenadines',
    code: 'VCT',
    status: 'ok'
  },
  {
    id: '236',
    country: 'Venezuela (Bolivarian Republic of)',
    code: 'VEN',
    status: 'ok'
  },
  {
    id: '237',
    country: 'Virgin Islands (British)',
    code: 'VGB',
    status: 'ok'
  },
  {
    id: '238',
    country: 'Virgin Islands (U.S.)',
    code: 'VIR',
    status: 'ok'
  },
  {
    id: '239',
    country: 'Viet Nam',
    code: 'VNM',
    status: 'ok'
  },
  {
    id: '240',
    country: 'Vanuatu',
    code: 'VUT',
    status: 'ok'
  },
  {
    id: '241',
    country: 'Wallis and Futuna',
    code: 'WLF',
    status: 'ok'
  },
  {
    id: '242',
    country: 'Samoa',
    code: 'WSM',
    status: 'ok'
  },
  {
    id: '243',
    country: 'Yemen',
    code: 'YEM',
    status: 'ok'
  },
  {
    id: '244',
    country: 'South Africa',
    code: 'ZAF',
    status: 'ok'
  },
  {
    id: '245',
    country: 'Zambia',
    code: 'ZMB',
    status: 'ok'
  },
  {
    id: '246',
    country: 'Zimbabwe',
    code: 'ZWE',
    status: 'ok'
  }
];
